import { render, staticRenderFns } from "./DocConfirmationSuccessModal.vue?vue&type=template&id=790e08ac&scoped=true"
import script from "./DocConfirmationSuccessModal.vue?vue&type=script&lang=js"
export * from "./DocConfirmationSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./DocConfirmationSuccessModal.vue?vue&type=style&index=0&id=790e08ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e08ac",
  null
  
)

export default component.exports